<template>

    <fragment>

        <div v-if="dataStore.faqOpen" class="faq-window">

            <div class="button-wrap">
                <button title="Tillbaka" class="btn btn-primary" v-on:click.prevent="goBack()" v-html="language.questions_answers_back"></button>
            </div>

            <h2 v-html="language.questions_answers"></h2>

            <ul class="faq">
                <li  class="question" v-for="faq in faqs" :key="faq.id">
                    <!-- v-on:click="e => e.target.parentElement.classList.toggle('active')" -->
                    <span>{{ faq.question }}</span>
                    <div class="answer">
                        {{ faq.answer }}
                    </div>
                </li>
            </ul>

            <div v-if="showMessage" class="alert" :class="type">
                <p>{{ message }}</p>
            </div>

            <fieldset>

                <legend v-html="language.ask_your_question"></legend>

                <form v-on:submit.prevent="submit" method="post" enctype=”multipart/form-data” >

                    <div class="form-group">
                        <textarea class="form-control" v-model="formQuestion" id="question" rows="10"></textarea>
                    </div>

                    <p v-html="language.questions_answers_disclaimer"></p>

                    <button :title="language.questions_answers_submit" class="btn btn-primary" :disabled="isSubmitting" v-html="language.questions_answers_submit"></button>

                </form>

            </fieldset>

        </div>

    </fragment>

</template>

<script>

import axios from 'axios'
import dataStore from './../store'
import { Fragment } from 'vue-fragment'

export default {

    inject: [ 'language' ],

    components: {
        Fragment
    },

    props: {
        project : Object,
    },

    mounted() {
        this.getFaq()
    },

    data() {
        return {
            formQuestion : '',
            showMessage : false,
            type : 'alert-success',
            message : '',
            faqs : [],
            dataStore,
            isSubmitting : false
        };
    },

    methods: {

        goBack: function() {
            return window.history.back();
        },

        submit: function() {

            if(this.formQuestion === '') {

                this.type = 'alert-danger'
                this.message = this.language.questions_answers_error
                this.showMessage = true

                setTimeout(() => {
                    this.showMessage = false
                }, 5000)

                return
            }

            else {
                this.isSubmitting = true
            }

            axios.post(
                `/api/faq-request`, {
                    question : this.formQuestion,
                    project : this.project.id
                }
            )
            .then(response => {
                this.formQuestion = ''
                this.message = response.data.message
                this.type = response.data.type
                this.showMessage = true
                this.isSubmitting = false


                setTimeout(() => {
                    this.showMessage = false
                }, 5000)
            })
            .catch(err => {
                console.error(err);
                this.formQuestion = ''
                this.type = 'alert-danger'
                this.message = err
                this.showMessage = true
                this.isSubmitting = false


                setTimeout(() => {
                    this.showMessage = false
                }, 5000)
            });

        },

        getFaq: function() {
            axios.get(`/api/faq/${this.project.id}`)
            .then(response => {
                if(!response.data ) return
                this.faqs = response.data
            })
            .catch(err => {
                console.error(err);
            });
        }

    }
};

</script>

